import { getTitlePrefix } from "@/config/env"

import { Head } from "./Head"

export function AppHead() {
  const titlePrefix = getTitlePrefix()

  return (
    <Head>
      <title>{`${titlePrefix}NexusGPT`}</title>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <meta property="og:url" content="https://gpt.nexus" />
      <meta property="og:type" content="website" key="ogtype" />
      <meta property="og:title" content="Nexus" key="ogtitle" />
      <meta name="twitter:card" content="summary" key="twcard" />
      <meta name="description" content="Build AI agent in minutes." key="desc" />
      <meta property="og:description" content="Build AI agent in minutes." key="ogdesc" />
      <meta property="og:image" content="https://gpt.nexus/hero.png" key="ogimage" />
    </Head>
  )
}
